<div class="container">
  <div class="row">
    <div class="col-md-3">
      <app-info-saas-cadastro></app-info-saas-cadastro>
    </div>

    <div class="col-md-9">
      <app-cadastro-formulario></app-cadastro-formulario>
    </div>
  </div>
</div>
